<template>
  <v-card
    border
    class="mt-4 pa-4"
  >
    <h4 class="mb-1 text-subtitle-2">
      {{ $t('delete-contact.title') }}
    </h4>
    <div class="text-grey text--darken-1 text-caption">
      {{ $t('delete-contact.subtitle') }}
    </div>

    <div class="justify-end mt-3 d-flex">
      <DeleteContact :lead="lead" />
    </div>
  </v-card>
</template>

<script>
import DeleteContact from './DeleteContact'

export default {
  components: {
    DeleteContact,
  },
  props: {
    lead: { type: Object, default: null },
  },
}
</script>
